import React from 'react';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: '🏗️',
      title: 'Commercial Construction',
      description: 'Expert commercial building solutions from ground up, including office spaces, retail centers, and industrial facilities.'
    },
    {
      icon: '🏠',
      title: 'Residential Building',
      description: 'Custom home construction and renovations that bring your vision to life with quality craftsmanship.'
    },
    {
      icon: '🔨',
      title: 'Renovation & Remodeling',
      description: 'Transform existing spaces with our comprehensive renovation services for both homes and businesses.'
    },
    {
      icon: '🏛️',
      title: 'Project Management',
      description: 'End-to-end project management ensuring your construction project is delivered on time and within budget.'
    },
    {
      icon: '📐',
      title: 'Design & Planning',
      description: 'Collaborative design and planning services to ensure your project meets all requirements and regulations.'
    },
    {
      icon: '🛠️',
      title: 'Maintenance Services',
      description: 'Ongoing maintenance and repair services to keep your property in excellent condition year-round.'
    }
  ];

  return (
    <section id="services" className="services">
      <div className="services-container">
        <div className="section-header">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            Comprehensive construction solutions tailored to your needs
          </p>
        </div>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
